/** Ícones da landing, copiados do protótipo (docs/prototipos/fonte/landing-modelo.html). */
import { SimboloMarca } from '../../components/marca/SimboloMarca';

/** O símbolo da marca (components/marca). Na landing o brilho respira; na wiki fica parado. */
export function Marca({ vivo = false }: { vivo?: boolean }) {
  return <SimboloMarca vivo={vivo} />;
}

export function Check() {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>;
}

export function Seta() {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>;
}

export function Estrela() {
  return (
    <svg viewBox="0 0 14 14" fill="currentColor" aria-hidden="true">
      <path d="M7 0 9 5 14 7 9 9 7 14 5 9 0 7 5 5Z" />
    </svg>
  );
}

export function Carta() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  );
}

export function Cadeado() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10" width="14" height="10" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function Balao() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 5h16v11H9l-5 4z" />
      <path d="M9 10h.01M15 10h.01" />
    </svg>
  );
}

export function Camera() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <path d="M17.5 6.5h.01" />
    </svg>
  );
}

/** Os oito cartões de "O que você encontra", na ordem de `landing.r1` a `landing.r8`. */
export const ICONES_RECURSOS = [
  <svg key="r1" viewBox="0 0 32 32" aria-hidden="true"><path d="M6 26 22 10M18 6l8 8M20 4l8 8-3 3-8-8z" /><path d="M6 26l-2 2M9 23l-3-3" /></svg>,
  <svg key="r2" viewBox="0 0 32 32" aria-hidden="true"><path d="M6 5h15a3 3 0 0 1 3 3v19H9a3 3 0 0 1-3-3z" /><path d="M6 24a3 3 0 0 1 3-3h15M11 10h8M11 14h6" /></svg>,
  <svg key="r3" viewBox="0 0 32 32" aria-hidden="true"><path d="M4 22h18l-3-5H8z" /><path d="M13 17V9l9-4 2 4-7 3v5M7 26h14" /></svg>,
  <svg key="r4" viewBox="0 0 32 32" aria-hidden="true"><path d="M16 4v24M8 9h16M8 9l-4 9h8zM24 9l-4 9h8z" /><path d="M11 28h10" /></svg>,
  <svg key="r5" viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3 27 7v8c0 7-5 12-11 14C10 27 5 22 5 15V7z" /><path d="M11 15l4 4 6-7" /></svg>,
  <svg key="r6" viewBox="0 0 32 32" aria-hidden="true"><path d="M5 27 19 13M27 27 13 13M9 9l4 4M23 9l-4 4M5 5l4 4M27 5l-4 4" /></svg>,
  <svg key="r7" viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="16" r="11" /><path d="M16 9v7l5 3" /></svg>,
  <svg key="r8" viewBox="0 0 32 32" aria-hidden="true"><path d="M4 27V14l12-9 12 9v13z" /><path d="M12 27v-8h8v8" /></svg>
] as const;
